var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_6403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0059 0C18.6288 0 24.0059 5.37703 24.0059 12C24.0059 18.623 18.6288 24 12.0059 24C5.38289 24 0.00585938 18.623 0.00585938 12C0.00585938 5.37703 5.38289 0 12.0059 0ZM19.1925 8.38959C19.02 7.74417 18.5118 7.236 17.8664 7.0635C16.6965 6.75 12.0059 6.75 12.0059 6.75C12.0059 6.75 7.31522 6.75 6.14531 7.0635C5.50008 7.236 4.99172 7.74417 4.81922 8.38959C4.50586 9.55936 4.50586 12.0001 4.50586 12.0001C4.50586 12.0001 4.50586 14.4407 4.81922 15.6104C4.99172 16.2558 5.50008 16.7642 6.14531 16.9366C7.31522 17.25 12.0059 17.25 12.0059 17.25C12.0059 17.25 16.6965 17.25 17.8664 16.9366C18.5118 16.7642 19.02 16.2558 19.1925 15.6104C19.5059 14.4407 19.5059 12.0001 19.5059 12.0001C19.5059 12.0001 19.5059 9.55936 19.1925 8.38959ZM10.5058 14.2501V9.75005L14.4029 12.0001L10.5058 14.2501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_6403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fda0148d5a9d2fa7b16f95baed24a08b.svg";
export { ForwardRef as ReactComponent };